import { render } from "./zsRaceSignCheck.vue?vue&type=template&id=63b88386&scoped=true"
import script from "./zsRaceSignCheck.vue?vue&type=script&lang=js"
export * from "./zsRaceSignCheck.vue?vue&type=script&lang=js"

import "./zsRaceSignCheck.vue?vue&type=style&index=0&id=63b88386&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b88386"]])

export default __exports__